
export default function Funding() {
  const fundingTypes = [
    {
      title: 'Fondos Europeos',
      description: 'Horizon Europe, FEDER, FSE+, FEADER',
      icon: 'ri-earth-line'
    },
    {
      title: 'Programas Nacionales',
      description: 'Plan de Recuperación, CDTI, IDAE',
      icon: 'ri-flag-line'
    },
    {
      title: 'Ayudas Regionales',
      description: 'Programas autonómicos y locales',
      icon: 'ri-map-pin-line'
    },
    {
      title: 'Financiación Privada',
      description: 'Inversores, crowdfunding, partnerships',
      icon: 'ri-hand-coin-line'
    }
  ];

  return (
    <section id="financiacion" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Te ayudamos a convertir tus ideas en proyectos financiados
            </h2>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Acceder a una ayuda no debería ser un laberinto. En <strong className="text-teal-600">Territorio360</strong> simplificamos el camino hacia la financiación pública y privada.
              </p>
              
              <p>
                Identificamos oportunidades, te guiamos en la documentación y te acompañamos hasta la justificación final. Trabajamos con fondos europeos, nacionales y regionales vinculados a la innovación, digitalización y desarrollo rural.
              </p>
              
              <blockquote className="border-l-4 border-teal-600 pl-6 italic text-xl text-gray-800 bg-white p-6 rounded-r-lg shadow-sm">
                <strong>Tu proyecto tiene valor. Nuestra misión es ayudarte a impulsarlo.</strong>
              </blockquote>
            </div>

            <div className="mt-8">
              <button className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
                Consulta tu proyecto
              </button>
            </div>
          </div>
          
          <div className="space-y-6">
            {fundingTypes.map((type, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${type.icon} text-xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {type.title}
                    </h3>
                    <p className="text-gray-600">
                      {type.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
